import SearchFilters from '../search-filters/SearchFilters'
import ProductCard from '../product-card/ProductCard'
import Pagination from '../pagination/Pagination'
import MapAllRemainingPanel from '../map-all-remaining-panel/MapAllRemainingPanel'
import { ReactComponent as EmptyList } from '../../../assets/icons/empty-list.svg'
import { Spinner } from 'reactstrap'

const ProductSelectionPanel = ({
    products,
    variants = [],
    onOpenMapAllModal,
    hasPriorityVariant,
    currentPage,
    totalPages,
    onPageChange,
    onProductSelect,
    filters,
    setFilters,
    onFilterChange,
    pageSize,
    onPageSizeChange,
    searching,
}) => {
    const recentlyViewedProducts = JSON.parse(sessionStorage.getItem('recentlyViewedProducts') || '[]')

    // Calculate unmapped variants
    const unmappedVariants = variants.filter(v => !v.isMapped) || []
    // Only show panel if there's a valid priority variant and unmapped variants exist
    const shouldShowPanel = hasPriorityVariant && unmappedVariants.length >= 1
    const displayRecently =
        recentlyViewedProducts.length > 0 &&
        filters?.category === '' &&
        filters.productType === 'all' &&
        filters.search === ''
    return (
        <div className="d-flex flex-column w-100" style={{ flex: '1 1' }}>
            <div className="left-panel">
                <div className="panel-header">
                    {shouldShowPanel && (
                        <MapAllRemainingPanel
                            unmappedCount={unmappedVariants.length}
                            onClick={onOpenMapAllModal}
                        />
                    )}

                    <div className="panel-title">
                        <h3>Map Merchize Product variants</h3>
                        <p>
                            Map products available for Shopify to process orders from Shopify (same for other platforms)
                        </p>
                    </div>

                    <SearchFilters onFilterChange={onFilterChange} filters={filters} setFilters={setFilters} />
                </div>
                {searching ? (
                    <Spinner style={{ color: '#007BFF' }} />
                ) : (
                    <div className="overflow-auto">
                        {displayRecently && (
                            <div className="recent-products mb-4">
                                <h4>Recently view Products</h4>
                                <div className="products-grid">
                                    {recentlyViewedProducts.map((product) => (
                                        <ProductCard
                                            key={product._id}
                                            product={product}
                                            onClick={() => onProductSelect?.(product)}
                                        />
                                    ))}
                                </div>
                            </div>
                        )}
                        <div className="recent-products mt-2">
                            <h4>All Products</h4>
                            {products.length > 0 || searching ? (
                                <div className="products-grid">
                                    {products.map((product) => (
                                        <ProductCard
                                            key={product._id}
                                            product={product}
                                            onClick={() => onProductSelect?.(product)}
                                        />
                                    ))}
                                </div>
                            ) : (
                                <div className="text-center">
                                    <EmptyList />
                                    <p className="mt-2">
                                        No products found for the keywords <b>"{filters.search}"</b>
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
                pageSize={pageSize}
                onPageSizeChange={onPageSizeChange}
            />
        </div>
    )
}

export default ProductSelectionPanel


